// lib/strings.ts

const strings = {
    // App Store Links
    appStoreUrl: 'https://apps.apple.com/in/app/wedding-invitation-card-maker/id6511243502', // Replace with your real URL
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.myweddinglyinvites', // Replace with your real URL
  
    // Website Pages
    homepage: 'https://www.myweddinglyinvites.com/',
    aboutUs: 'https://www.myweddinglyinvites.com/about-us',
    privacyPolicy: 'https://www.myweddinglyinvites.com/privacy-policy',
    terms: 'https://www.myweddinglyinvites.com/terms-and-conditions',
    contact: 'https://www.myweddinglyinvites.com/contact-us',
  
    // Social Media (optional)
    instagram: 'https://www.instagram.com/myweddinglyinvites',
    facebook: 'https://www.facebook.com/myweddinglyinvites',
    youtube: 'https://www.youtube.com/@myweddinglyinvites',
  
    // QR Codes (optional)
    qrCodeImage: '/qr-code-placeholder.png',
  };
  
  export default strings;
  